import { render, staticRenderFns } from "./ApplyMail.vue?vue&type=template&id=98626178&scoped=true&"
import script from "./ApplyMail.vue?vue&type=script&lang=js&"
export * from "./ApplyMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98626178",
  null
  
)

export default component.exports